module.exports = __webpack_public_path__ + "img/202410_05.a95c628f.jpg";